/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Paper, Stack, Typography } from "@mui/material";
import Icon from "@/src/components/Icon/Icon";
import IconFolderCheck from "@/src/assets/iconsRedesign2026/generic/toggleable/IconFolderCheck";
import IconButtonLegalbird from "@/src/components/legalbird/IconButtonLegalbird/IconButtonLegalbird";
import { Delete } from "@mui/icons-material";

export type FilePreviewProps = {
  name: string;
  onDelete: () => void;
};

export default function FilePreview({ name, onDelete }: FilePreviewProps) {
  return (
    <Paper
      sx={(theme) => ({
        padding: "1rem",
        border: `1px solid ${theme.palette.divider}`,
      })}
      elevation={0}
    >
      <Stack direction={"row"} spacing={2} sx={{ alignItems: "center" }}>
        <Icon icon={IconFolderCheck} variant={"bordered"} />
        <Typography variant={"button"} noWrap sx={{ flexGrow: 1 }}>
          {name}
        </Typography>
        <IconButtonLegalbird label={"Datei entfernen"} variant={"text"} onClick={onDelete}>
          <Delete />
        </IconButtonLegalbird>
      </Stack>
    </Paper>
  );
}
